import { Advance, Charge, Fee } from '@willow/graphql-iso/src/app';

export function isFee(item: Charge): item is Fee {
  return item.__typename === 'Fee';
}

export function isAdvance(item: Charge): item is Advance {
  return item.__typename === 'Advance';
}
